import React from 'react';
import dayjs from 'dayjs';

export const FactColumns = [
  {
    header: 'Dataset',
    accessorKey: 'Dataset',
    size: 100,
    enableColumnFilter: false,
    enableSorting: false
  },
  {
    header: 'Data Provider',
    accessorKey: 'dataProvider',
    size: 100,
    enableColumnFilter: false,
    enableSorting: false
  },
  {
    header: 'Data Provider Type',
    accessorKey: 'DirectIndirect',
    minWidth: 160,
    enableColumnFilter: false,
    enableSorting: false
  },
  // {
  //   header: 'External Category',
  //   accessorKey: 'category',
  //   minWidth: 160,
  //   enableColumnFilter: false,
  //   enableSorting: false
  // },
  {
    header: 'Country',
    accessorKey: 'country',
    size: 120,
    enableColumnFilter: false,
    enableSorting: false
  },
  // {
  //   header: 'Filename',
  //   accessorKey: 'fileName',
  //   size: 100,
  //   enableColumnFilter: false,
  //   enableSorting: false
  // },
  // {
  //   header: 'Loaded On',
  //   accessorKey: 'createdOn',
  //   enableColumnFilter: false,
  //   Cell: ({ value }: any) => dayjs(value).format('DD/MMM/YY hh:mm a')
  // },
  // {
  //   header: 'Records',
  //   columns: [
  //     {
  //       header: 'Mapped',
  //       accessorKey: 'TotalMappedRecords',
  //       size: 100,
  //       enableColumnFilter: false,
  //       enableSorting: true
  //     },
  //     {
  //       header: 'Unprocessed',
  //       accessorKey: 'TotalUnprocessedRecords',
  //       size: 100,
  //       enableColumnFilter: false,
  //       enableSorting: true
  //     },
  //     {
  //       header: 'Mapped by SME',
  //       accessorKey: 'TotalRecordsMappedBySME',
  //       size: 100,
  //       enableColumnFilter: false,
  //       enableSorting: true
  //     },
  //     {
  //       header: 'Total',
  //       accessorKey: 'TotalRecords',
  //       size: 100,
  //       enableColumnFilter: false,
  //       enableSorting: true
  //     },
  //     {
  //       header: 'Success Status(%)',
  //       size: 100,
  //       accessorKey: 'successStatus',
  //       enableColumnFilter: false,
  //       enableSorting: false,
  //       Cell: (cell: any) => {
  //         const original = cell.row.original;
  //         const mappedCount = original.mappedRecordCount ?? 0;
  //         const total = original.total ?? 0;
  //         const successStatus = ((mappedCount / total) * 100).toFixed(2);
  //         return <div>{successStatus}</div>;
  //       }
  //     }
  //   ]
  // }
];
